/* tslint:disable */
/* eslint-disable */
/**
 * SDPS Preprocessing API
 * The pre-processing service manages batches submitted to the SDP.  <br> There are two services available: Contents and Events
 *
 * The version of the OpenAPI document: 0.1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * A note of a Transfer
 * @export
 * @interface TransferNote
 */
export interface TransferNote {
    /**
     * 
     * @type {string}
     * @memberof TransferNote
     */
    content: string;
    /**
     * 
     * @type {Date}
     * @memberof TransferNote
     */
    noteCreatedAt?: Date;
    /**
     * Creator of note
     * @type {string}
     * @memberof TransferNote
     */
    noteCreatedBy?: string;
}

/**
 * Check if a given object implements the TransferNote interface.
 */
export function instanceOfTransferNote(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "content" in value;

    return isInstance;
}

export function TransferNoteFromJSON(json: any): TransferNote {
    return TransferNoteFromJSONTyped(json, false);
}

export function TransferNoteFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransferNote {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'content': json['content'],
        'noteCreatedAt': !exists(json, 'note_created_at') ? undefined : (new Date(json['note_created_at'])),
        'noteCreatedBy': !exists(json, 'note_created_by') ? undefined : json['note_created_by'],
    };
}

export function TransferNoteToJSON(value?: TransferNote | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'content': value.content,
        'note_created_at': value.noteCreatedAt === undefined ? undefined : (value.noteCreatedAt.toISOString()),
        'note_created_by': value.noteCreatedBy,
    };
}

